import { IconButton } from "@mui/material";
import { SnackbarProvider as NotistackSnackbarProvider } from "notistack";
import type { SnackbarKey, SnackbarProviderProps } from "notistack";
import { createRef } from "react";
import type { ReactNode } from "react";
import CloseIcon from "@mui/icons-material/Close";

function SnackbarProvider({
  maxSnack = 3,
  autoHideDuration = 10000, // 10s
  ...props
}: Readonly<SnackbarProviderProps>): ReactNode {
  // On ajoute à chaque snackbar un bouton pour la fermer
  const notistackRef = createRef<NotistackSnackbarProvider>();
  const onClickDismiss = (key: SnackbarKey) => () => {
    notistackRef?.current?.closeSnackbar(key);
  };

  function closeButton(key: SnackbarKey): ReactNode {
    return (
      <IconButton onClick={onClickDismiss(key)} sx={{ color: "white" }}>
        <CloseIcon />
      </IconButton>
    );
  }

  return (
    <NotistackSnackbarProvider
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "center",
      }}
      maxSnack={maxSnack}
      autoHideDuration={autoHideDuration}
      ref={notistackRef}
      action={closeButton}
      preventDuplicate
      {...props}
    />
  );
}

export default SnackbarProvider;
